import React from 'react';

const SEO = () => {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${origin}/#business`,
    "name": "Hollis K-9 Coaching",
    "alternateName": "Complete Canine Dog Training Oklahoma",
    "image": [
      `${origin}/og-image.jpg`,
      `${origin}/hollis-logo-black.png`
    ],
    "logo": `${origin}/hollis-logo-black.png`,
    "url": origin,
    "telephone": "+19185009422",
    "email": "hollisk9coaching@gmail.com",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Tulsa",
      "addressRegion": "OK",
      "postalCode": "74101",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 36.1539,
      "longitude": -95.9928
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "16:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/hollisk9coaching",
      "https://www.hollisk9.com"
    ],
    "description": "Professional dog training in Tulsa, Broken Arrow, Owasso, Jenks, Bixby, Sand Springs, Sapulpa, Claremore, Bartlesville, Muskogee & Stillwater, OK. Expert K9 coaching, behavior modification, obedience training, board & train, virtual sessions. Serving all of Northeast Oklahoma.",
    "founder": {
      "@type": "Person",
      "name": "Courtney Hollis",
      "jobTitle": "Professional Dog Trainer & K9 Behavior Specialist"
    },
    "areaServed": [
      { "@type": "City", "name": "Tulsa", "containedIn": { "@type": "State", "name": "Oklahoma" } },
      { "@type": "City", "name": "Broken Arrow", "containedIn": { "@type": "State", "name": "Oklahoma" } },
      { "@type": "City", "name": "Owasso", "containedIn": { "@type": "State", "name": "Oklahoma" } },
      { "@type": "City", "name": "Jenks", "containedIn": { "@type": "State", "name": "Oklahoma" } },
      { "@type": "City", "name": "Bixby", "containedIn": { "@type": "State", "name": "Oklahoma" } },
      { "@type": "City", "name": "Sand Springs", "containedIn": { "@type": "State", "name": "Oklahoma" } },
      { "@type": "City", "name": "Sapulpa", "containedIn": { "@type": "State", "name": "Oklahoma" } },
      { "@type": "City", "name": "Claremore", "containedIn": { "@type": "State", "name": "Oklahoma" } },
      { "@type": "City", "name": "Bartlesville", "containedIn": { "@type": "State", "name": "Oklahoma" } },
      { "@type": "City", "name": "Muskogee", "containedIn": { "@type": "State", "name": "Oklahoma" } },
      { "@type": "City", "name": "Stillwater", "containedIn": { "@type": "State", "name": "Oklahoma" } }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Dog Training Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Private Dog Training",
            "description": "One-on-one personalized dog training sessions in your home or at our facility in Tulsa, OK"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Virtual Dog Training",
            "description": "Remote dog training coaching sessions available from anywhere via video call"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Board and Train Program",
            "description": "Intensive residential dog training program where your dog stays with us for daily professional training"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Group Training Classes",
            "description": "Structured group dog training classes for socialization and obedience in Tulsa, OK"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Behavior Modification",
            "description": "Specialized training for reactive and aggressive dogs with customized behavior modification plans"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": "14",
      "reviewCount": "14"
    }
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Hollis K-9 Coaching",
    "url": origin,
    "logo": `${origin}/hollis-logo-black.png`,
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+19185009422",
      "contactType": "customer service",
      "areaServed": "US",
      "availableLanguage": "English"
    }
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Hollis K-9 Coaching",
    "url": origin,
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${origin}/services`,
      "query-input": "required name=search_term_string"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${origin}/` },
      { "@type": "ListItem", "position": 2, "name": "Services", "item": `${origin}/services` },
      { "@type": "ListItem", "position": 3, "name": "About", "item": `${origin}/about` },
      { "@type": "ListItem", "position": 4, "name": "Testimonials", "item": `${origin}/testimonials` },
      { "@type": "ListItem", "position": 5, "name": "FAQ", "item": `${origin}/faq` },
      { "@type": "ListItem", "position": 6, "name": "Gallery", "item": `${origin}/gallery` },
      { "@type": "ListItem", "position": 7, "name": "Contact", "item": `${origin}/contact` }
    ]
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
    </>
  );
};

export default SEO;
